<template>
  <v-app>
    <v-main style="background: #EFEFEF;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
